<template>
    <header class="header navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    
        <div class="navbar-left-wrap">
    
            <!-- 1. Navigation Left logo -->
            <h1 class="navbar-brand mr-0 mr-md-2">
                <router-link to="/">
                    大琉球語辞典
                </router-link>
            </h1>
            <span class="badge-navbar">
                        <a href="http://www.u-ryukyu.ac.jp/" target="_blank" class="badge badge-pill badge-primary">
                        琉球大学HP
                        <i class="material-icons font-13 font-middle">open_in_new</i>
                    </a>
                </span>
            <span class="navbar-brand-name">
                    UNIVERSITY OF THE RYUKYUS
                </span>
        </div>
        <!-- / navbar-left-wrap -->
    
        <div class="navbar-right-wrap">
    
            <!-- 2. Navigation Right menu -->
            <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
                <li class="nav-item">
                    <a class="js-btn-menu" @click="clickDispTop">
                        <i class="material-icons">home</i> メニュー
                    </a>
                </li>
                <li class="nav-item">
                    <a class="js-btn-guide" @click="clickDispGuide">
                        <i class="material-icons">help</i>{{gide_title}} 
                    </a>
                    <li class="nav-item">
                        <a class="js-btn-search" @click="clickDispSearch">
                            <i class="material-icons">search</i> 検索する
                        </a>
                    </li>
            </ul>
        </div>
        <!-- / navbar-right-wrap -->
    </header>
</template>
<style>
.js-btn-menu,.js-btn-guide,.js-btn-search{
cursor: pointer;
cursor: hand;
}
</style>
<script>
    import {
        API_URL
    } from "@/services/config";

    export default {
        name: "SearchPage",
        props: {
            msg: String
        },
        computed:{
            jpListData() {
                return this.$store.getters.jpListData.list;
            },
        },
        data(){
            return {
            gide_title:''
            }
        },
        mounted(){
            var self=this;
            var params = new URLSearchParams();
            params.append('menu_id',9999);
            self.$axios.post(`${API_URL}/search/getcontent`, params)
            .then((res)=>{
                self.gide_title = res.data.title; 
            });

        },
        methods: {
            clickDispSearch() {
                var self = this;
                if (this.$store.getters.isSearchBox === false) {
                    self.$store.dispatch("upIsWide", false);
                    self.$store.dispatch("upIsSearchBox", true); //!this.$store.getters.isSearchBox);
                }else{
                    if(this.jpListData !== undefined && this.jpListData.length>0){
                    self.$store.dispatch("upIsWide", false);
                    self.$store.dispatch("upIsSearchBox", false); //!this.$store.getters.isSearchBox);
                    this.$router.push('/search',()=>{});
                    }
                }
            },
            clickDispTop() {
                this.$store.dispatch("upIsSearchBox", true);
                 this.$store.dispatch("upIsGuide", false);
                this.$router.push("/",()=>{});
            },
            clickDispGuide() {
                this.$store.dispatch("upIsGuide", !this.$store.getters.isGuide);
            }
        }
    };
</script>